(function () {
  'use strict';
  if (window.EliteCartPromotions) return;

  var root = window.Shopify && window.Shopify.routes.root || window.routes && window.routes.rootUrl || '/';
  var queue = Promise.resolve();
  var pending = 0;
  var legacyCleanup = null;
  var refreshPending = false;

  async function request(path, data) {
    var options = { credentials: 'same-origin', cache: 'no-store' };
    if (data !== undefined) {
      options.method = 'POST';
      options.headers = { 'Content-Type': 'application/json' };
      options.body = JSON.stringify(data);
    }
    var response = await fetch(root + path, options);
    var cart;
    try { cart = await response.json(); } catch (error) {
      throw new Error('No pudimos actualizar tu carrito. Inténtalo de nuevo.');
    }
    if (!response.ok) throw new Error(cart.description || cart.message || 'No pudimos actualizar tu carrito. Inténtalo de nuevo.');
    return cart;
  }

  function serialize(job) {
    pending += 1;
    var result = queue.then(job);
    queue = result.catch(function () {});
    return result.finally(function () {
      pending -= 1;
      if (!pending && refreshPending) {
        refreshPending = false;
        document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { eliteCartPromotions: true } }));
      }
    });
  }

  function normalize(codes) {
    if (!Array.isArray(codes)) throw new TypeError('Discount codes must be an array.');
    var seen = Object.create(null);
    return codes.reduce(function (out, code) {
      if (typeof code !== 'string') throw new TypeError('Every discount code must be a string.');
      var value = code.trim();
      var key = value.toUpperCase();
      if (value && key !== 'TITANIUM15' && !seen[key]) {
        seen[key] = true;
        out.push(value);
      }
      return out;
    }, []);
  }

  function cartCodes(cart) {
    return (cart.discount_codes || []).map(function (entry) { return entry.code; });
  }

  async function replaceCodes(cart, codes) {
    var previous = normalize(cartCodes(cart));
    try {
      var updated = await request('cart/update.js', { discount: '' });
      if (codes.length) updated = await request('cart/update.js', { discount: codes.join(',') });
      if (cartCodes(updated).some(function (code) { return code.toUpperCase() === 'TITANIUM15'; })) {
        throw new Error('No pudimos quitar el descuento anterior. Inténtalo de nuevo.');
      }
      refreshPending = true;
      return updated;
    } catch (error) {
      try {
        await request('cart/update.js', { discount: '' });
        if (previous.length) await request('cart/update.js', { discount: previous.join(',') });
        refreshPending = true;
      } catch (restoreError) {
        throw new Error('No pudimos restaurar tus descuentos. Revisa tu carrito antes de finalizar la compra.');
      }
      throw error;
    }
  }

  function readCart() {
    return serialize(function () { return request('cart.js'); });
  }

  function applyCodes(codes) {
    var desired;
    try { desired = normalize(codes); } catch (error) { return Promise.reject(error); }
    return serialize(async function () {
      var cart = await request('cart.js');
      return replaceCodes(cart, desired);
    });
  }

  // Read, decide and derive removals inside one queue job, never from caller snapshots.
  function removeCodesWhen(codes, predicate) {
    var targets;
    try {
      targets = normalize(codes).map(function (code) { return code.toUpperCase(); });
      if (typeof predicate !== 'function') throw new TypeError('Discount predicate must be a function.');
    } catch (error) { return Promise.reject(error); }
    return serialize(async function () {
      var cart = await request('cart.js');
      var decision = predicate(cart);
      if (typeof decision !== 'boolean') {
        // Consume a rejected async result, but never use it to authorize a mutation.
        if (decision && typeof decision.then === 'function') Promise.resolve(decision).catch(function () {});
        throw new TypeError('Discount predicate must return a synchronous boolean.');
      }
      if (!decision) return cart;
      var current = normalize(cartCodes(cart));
      var desired = current.filter(function (code) { return targets.indexOf(code.toUpperCase()) === -1; });
      if (desired.length === current.length) return cart;
      return replaceCodes(cart, desired);
    });
  }

  function cleanLegacy() {
    if (legacyCleanup) return legacyCleanup;
    legacyCleanup = serialize(async function () {
      var cart = await request('cart.js');
      var current = cartCodes(cart);
      if (!current.some(function (code) { return code.toUpperCase() === 'TITANIUM15'; })) return cart;
      return replaceCodes(cart, normalize(current));
    });
    legacyCleanup.then(function () { legacyCleanup = null; }, function () { legacyCleanup = null; });
    return legacyCleanup;
  }

  var api = { readCart: readCart, applyCodes: applyCodes, removeCodesWhen: removeCodesWhen, cleanLegacy: cleanLegacy };
  Object.defineProperty(api, 'busy', { enumerable: true, get: function () { return pending > 0; } });
  window.EliteCartPromotions = api;

  function autoClean(event) {
    if (event && event.detail && event.detail.eliteCartPromotions) return;
    cleanLegacy().catch(function () {});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', autoClean, { once: true });
  else autoClean();
  ['cart:updated', 'cart:change', 'cart:refresh', 'cart:rerendered'].forEach(function (name) {
    document.addEventListener(name, autoClean);
  });
}());
